(function () {
	'use strict';

	/**
	* @ngdoc service
	* @name  smb-app.smbUsersDataStore
	* 
	* @description 
	* A datastore used to retrieve smb-app users
	**/

	angular
		.module('smb-app')
		.factory('smbUsersDataStore',
		[
			'pxAuthService',
			'sbUsersService',
			UsersDataStore
		]);

	function UsersDataStore(pxAuthService, sbUsersService) {
		var _users = [];

		return {
			/**
			* @ngdoc method
			* @name smbUsersDataStore#getUsers
			* @methodOf smb-app.smbUsersDataStore
			* @kind function
			*
			* @description
			* Gets a collection of users
			*
			* @returns {Deferred} A promise that will resolve with a collection of users
			* 
			*/
			getUsers: getUsers,

			/**
			* @ngdoc property
			* @name smbUsersDataStore#users
			* @propertyOf smb-app.smbUsersDataStore
			* @kind property
			*
			* @description
			* A collection of users
			* 
			* @returns {array} An array of users
			*/
			get users() { return _users; }
		};

		function getUsers() {
			return sbUsersService
				.getUsers(pxAuthService.systemName)
				.then(function (response) {
					_users = response;	
					return response;
				});
		}
	}

})();


//////////////////
// WEBPACK FOOTER
// ./app/dataStores/usersDataStore.js
// module id = 133
// module chunks = 1